module.exports = __webpack_public_path__ + "static/media/lehman_race_time_720.0851a410.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/lehman_race_time_720.png
// module id = 361
// module chunks = 0